import { useMemo, useState } from "react";

export function useLineChartActionsHookFactory() {
  const [dateFilter, setDateFilter] = useState(null)

  return useMemo(() => ({
    dateFilter,
    setDateFilter,
  }), [dateFilter])
}
